/**
 * Quem está respondendo, do ponto de vista da telemetria.
 *
 * Não há contas nem login: o identificador é um número aleatório guardado neste
 * navegador, que serve para amarrar as respostas de uma mesma pessoa numa mesma
 * máquina — o suficiente para calibrar. Antes disso era a palavra "demo", cravada, e
 * toda a telemetria saía com o mesmo nome.
 *
 * Nada aqui identifica a pessoa: o valor não sai do navegador, a não ser dentro do
 * código de resultados que ela mesma copia e entrega ao professor.
 */

const CHAVE = 'itens-iterativos:pessoa';

export function idDaPessoa(): string {
  try {
    const guardado = localStorage.getItem(CHAVE);
    if (guardado) return guardado;
    const novo = `p-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(CHAVE, novo);
    return novo;
  } catch {
    // Armazenamento bloqueado: um id por sessão ainda é melhor que um id por produto.
    return `p-${Math.random().toString(36).slice(2, 10)}`;
  }
}
